var Kowloon = "เกาลูน";
var HKStates = {
	"Hong Kong Island": "เกาะฮ่องกง",
	Kowloon: Kowloon,
	"Lantau Island": "เกาะลันเตา",
	"New Territories": "นิวเทร์ริทอรีส์"
};

export { Kowloon, HKStates as default };
